import React from 'react';
import { Icons } from '../../Icons';
export const chevronIcon = React.createElement(Icons, { iconName: "ic-ui-chevron-down", className: "ic-ui-chevron-down" });
//# sourceMappingURL=icons.js.map